import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const Row = ({ bg, hover, children }) => (
  <div className={classNames('custom-table__row', {
    'custom-table__row-hover': hover,
    'custom-table__row-bg': bg,
  })}
  >
    {children}
  </div>
);

Row.defaultProps = {
  hover: false,
  bg: false,
}

Row.propTypes = {
  bg: PropTypes.bool,
  hover: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}
